module.exports = __webpack_public_path__ + "static/media/hospital.c7279d6f.svg";